import React from 'react';
import PressNews from '../components/PressNews';

const News = () => <PressNews fullPage />;

export default News;
